class Incrementer {
  constructor(options = {}) {
    this.config = {
      modules: () => document.querySelectorAll('[data-module="incrementer"]'),
      ...options
    };
  }

  init() {
    const { modules } = this.config;

    modules().forEach(_incrementer => {
      const incrementer = _incrementer;
      let { incrementBy } = incrementer.dataset;
      if (incrementer.dataset.initialized) return;
      if (!incrementBy || parseInt(incrementBy, 10) <= 0) {
        incrementBy = 1;
      }

      const buttonMinus = incrementer.querySelector('[data-type="minus"]');
      const buttonPlus = incrementer.querySelector('[data-type="plus"]');
      const quantityElement = incrementer.querySelector('input[name="quantity"]');

      if (!buttonMinus || !buttonPlus) {
        return;
      }
      buttonMinus.addEventListener('click', () => {
        if (parseInt(quantityElement.value, 10) > 1) {
          quantityElement.value = parseInt(quantityElement.value, 10) - parseInt(incrementBy, 10);
        }
      });
      buttonPlus.addEventListener('click', () => {
        quantityElement.value = parseInt(quantityElement.value, 10) + parseInt(incrementBy, 10);
      });

      incrementer.dataset.initialized = true;
    });
  }
}

export default Incrementer;
